import { useEffect, useState } from 'react';
import httpInstance from '../httpInstance';

const useScreensAppPersonas = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const endpoint = '/back-office/v1/parameters/PROMO_SCREEN';

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await httpInstance.get(endpoint);
        setData(response.data);
      } catch (err) {
        setError(err.response);
      }
    };

    fetchData();
  }, []);

  return { data, error };
};

export default useScreensAppPersonas;
